import { render } from "./Chat.vue?vue&type=template&id=539a66fc"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"
script.render = render

export default script